import React, { FC, useCallback } from 'react';

import { Button } from '@eika/button';

import { LoanView } from '../../components/LoanView';
import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import { useAccount } from '../../fetchHooks/useAccount';
import useAccountId from '../../hooks/queryparams/useAccountId';
import useTranslation from '../../hooks/useTranslation';
import { TransactionList } from '../TransactionList';

const Loan: FC = () => {
    const accountId = useAccountId();

    const translated = useTranslation();

    const accountState = useAccount(accountId);

    const refresh = useCallback(() => {
        accountState.refetch();
    }, [accountState]);

    if (accountState.error) {
        return (
            <>
                <ErrorCardWrapper exception={accountState.error} defaultError={translated.loanError}>
                    <Button onClick={refresh}>{translated.tryAgain}</Button>
                </ErrorCardWrapper>
            </>
        );
    }

    return (
        <>
            <LoanView account={accountState.data} accountIsLoading={!accountState.isFetched} />
            <TransactionList isLoanView />
        </>
    );
};

export default Loan;
